module.exports = __webpack_public_path__ + "img/4-2.74d56311.png";